import React from "react";
import withLanguageContext from "lib/hocs/withLanguageContext";
import { Typography } from "Components/Base/DataDisplay/Typography";
import { Box } from "Components/Base/Layout/Box";
import BaseGrid from "Components/Fragment/BaseGrid";
import {
  LearningActivityCard,
  LearningActivityListItem,
} from "Components/Module/LearningActivityItem";
import ActivityDescription from "Components/Module/LearningActivityItem/Description";
import {
  getCardImage,
  useRating,
} from "Components/Module/LearningActivityItem/functions";
import Rating from "lib/components/Rating";
import { useDisplayLearningActivityCardImage } from "lib/hocs/useLearningActivityCardState";
import CourseDates from "./Dates";
import { ClassroomCourseChips } from "./Chips";
import { ClassroomActions } from "./Actions";
import { useMyLearning } from "../../context";

const ClassroomItem = ({
  course,
  isManagerOrAdmin,
  openDetails,
  languageContext,
  basePath,
}) => {
  const { listView } = useMyLearning();
  const { rating, comment, updateRating } = useRating(course);
  const displayImage = useDisplayLearningActivityCardImage();
  const { imageComponent } = getCardImage(
    course,
    displayImage,
    false,
    listView ? "small" : "medium",
  );

  const isConnectedToMicrosoftTeams = Boolean(course.microsoftTeamId);
  const isRequested = course.requested;
  const displayDates = !isRequested;

  const ClassroomItemType = listView
    ? LearningActivityListItem
    : LearningActivityCard;

  return (
    <ClassroomItemType
      id={`learningActivityCard${course.courseId}`}
      title={course.title}
      type={course.courseType}
      displayImage={displayImage}
      imageComponent={imageComponent}
      chips={
        <ClassroomCourseChips
          course={course}
          completed={course.completed}
          languageContext={languageContext}
        />
      }
      content={
        <>
          <BaseGrid justifyContent="space-between" childWidth="auto">
            {course.allowRating && !isRequested && (
              <Rating
                currentRating={rating || 0}
                currentComment={comment || ""}
                type={course.courseType}
                objectId={course.courseId}
                updateRating={updateRating}
                readOnly={false}
                managerView={isManagerOrAdmin}
              />
            )}
          </BaseGrid>

          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Typography variant="h4" sx={{ fontWeight: "normal" }}>
              {languageContext("classroom")}
            </Typography>
            {displayDates && (
              <CourseDates course={course} languageContext={languageContext} />
            )}
          </Box>
          <ActivityDescription
            description={course.description}
            maxLength={listView ? 10000 : 100}
          />
        </>
      }
      actions={
        <ClassroomActions
          course={course}
          isManagerOrAdmin={isManagerOrAdmin}
          openDetails={openDetails}
          basePath={basePath}
          languageContext={languageContext}
        />
      }
    />
  );
};

export default withLanguageContext(ClassroomItem, "ActivityCentre");
